import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from 'app/services/excel-service/excel.service';
import { SanctionService } from '../../../../services/table-management/sanction.service';
import { SanctionFormComponent } from '../sanction-form/sanction-form.component';

@Component({
  selector: 'app-sanction-list',
  templateUrl: './sanction-list.component.html',
  styleUrls: ['./sanction-list.component.css'],
  providers: [SanctionService],
  standalone: false,
})
export class SanctionListComponent extends EntityListComponent<Rest.InvSanction> implements OnInit {

  @ViewChild(SanctionFormComponent, { static: true })
  sanctionForm: SanctionFormComponent;

  title: string = this.translateService.instant('tableManagement.sanction.sanction');
  EnabledFilter: SelectItem[];
  isCreateGranted: boolean;
  isDeleteGranted: boolean;
  isDelegationUser: boolean;

  @Input() vehicle: Rest.Vehicle;
  @Input() driver: Rest.InvDriver;

  constructor(
    private sanctionService: SanctionService,
    protected confirmationService: ConfirmationService,
    public notificationsService: NotificationsService,
    protected i18n: I18nService,
    authenticationService: AuthenticationService,
    protected loadingService: LoadingService,
    protected userTime: UserTimePipe,
    protected excelService: ExcelService,
    protected translateService: TranslateService,
  ) {
    super(
      sanctionService,
      confirmationService,
      notificationsService,
      i18n,
      authenticationService,
      loadingService,
      userTime,
      excelService
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.form = this.sanctionForm;
    this.setPermissions();
  }

  beforeLoad() {
    if (this.vehicle) this.paginationRequest.filters['vehicleId'] = [this.vehicle.id.toString()];
    if (this.driver) this.paginationRequest.filters['driver'] = [ this.driver.employee.user.surname1 + " " + this.driver.employee.user.surname2 + ", " + this.driver.employee.user.name],

    this.paginationRequest.sortAsc = false;
  }

  afterLoad() {}

  excelColumns = {};

  exportExcel() {
    this.setExcelColumns();
    super.exportExcelWithColumns(this.translateService.instant('tableManagement.sanction.sanction'), this.excelColumns);
  }

  setExcelColumns() {
    const vehicle = (e: any) => e.vehicle?.name ?? '';
    const driver = (e: any) => `${e.driver?.employee?.user?.surname1 ?? ''} ${e.driver?.employee?.user?.surname2 ?? ''}, ${e.driver?.employee?.user?.name ?? ''}`;
    const reason = (e: any) => e.reason?.reason ?? '';
    const date = (e: any) => e.date ?? '';
    const issuer = (e: any) => e.issuer ?? '';
    const amount = (e: any) => e.amount ?? '';
    const points = (e: any) => e.points ?? '';

    this.excelColumns = {
      [this.translateService.instant('general.vehicle')]: { bindField: vehicle },
      [this.translateService.instant('tableManagement.sinister.driver')]: { bindField: driver },
      [this.translateService.instant('tableManagement.sanction.reason')]: { bindField: reason },
      [this.translateService.instant('tableManagement.sanction.date')]: { bindField: date },
      [this.translateService.instant('tableManagement.sanction.issuer')]: { bindField: issuer },
      [this.translateService.instant('tableManagement.sanction.amount')]: { bindField: amount },
      [this.translateService.instant('tableManagement.sanction.points')]: { bindField: points },
    };
  }

  deleteSanction(sanction: Rest.InvSanction) {
    this.sanctionService.deleteById(sanction.id).then((response) => {
      if (response) {
        this.notificationsService.add(Severity.success, '', this.translateService.instant('general.deleteSuccessfull'));
        this.refresh();
      } else {
        this.notificationsService.add(Severity.error, '', this.translateService.instant('general.deleteError'));
      }
    });
  }

  public onDeleteSanction(sanction: Rest.InvSanction) {
    if (!this.isDeleteGranted) return;
    this.confirmationService.confirm({
      accept: () => { this.deleteSanction(sanction); },
      key: 'sanction-list'
    });
  }

  setPermissions() {
    const user = this.authenticationService.user;
    this.isCreateGranted = this.authenticationService.isRoleGranted('INV_SANCTION_CREATE', user);
    this.isDeleteGranted = this.authenticationService.isRoleGranted('INV_SANCTION_DISABLE', user);
    this.isDelegationUser = !this.authenticationService.isRoleGranted('INV_DELEGATIONS_ADMIN', user);
  }

  openDialog(sanction: Rest.InvSanction) {
    if (!this.isDelegationUser) {
      this.editDialog(sanction);
    }
  }
}

